import type { ReactNode } from "react";

/** Общие кусочки A2: карточка с надзаголовком, select, точка статуса. */

export const SELECT_CLS = "rounded-sm border border-bd2 bg-bg2 px-2 py-[5px] font-mono text-[11.5px] text-ink outline-none focus:border-acc disabled:cursor-not-allowed disabled:border-dashed disabled:text-mut";
export const INPUT_CLS = "rounded-sm border border-bd2 bg-bg2 px-[11px] py-[7px] font-mono text-[12.5px] text-ink outline-none placeholder:text-mut focus:border-acc";

export function Card({ eyebrow, children, className = "", testId }: { eyebrow: string; children: ReactNode; className?: string; testId?: string }) {
  return (
    <section className={`rounded-md border border-bd bg-card ${className}`} data-testid={testId}>
      <h2 className="m-0 border-b border-bd px-3.5 py-[9px] font-mono text-[10.5px] font-normal uppercase tracking-[.06em] text-mut">{eyebrow}</h2>
      <div className="p-3.5">{children}</div>
    </section>
  );
}

export function Eyebrow({ children }: { children: ReactNode }) {
  return <h3 className="m-0 mb-2.5 font-mono text-[10.5px] font-normal uppercase tracking-[.06em] text-mut">{children}</h3>;
}

export function Dot({ tone, size = 6 }: { tone: string; size?: number }) {
  return <span aria-hidden className="inline-block flex-none rounded-full" style={{ width: size, height: size, background: `var(--${tone})` }} />;
}

/** Классы цвета текста по тону — литералами, чтобы Tailwind их увидел. */
export const TONE_TEXT: Record<string, string> = { ok: "text-ok", acc: "text-acc", warn: "text-warn", err: "text-err", mut: "text-mut", info: "text-info", ink2: "text-ink2" };
